module.exports = __webpack_public_path__ + "static/media/Fallecimiento1.8e57ee6d.svg";